import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoshanishingnapurcab() {



  const cardData = {
    keyword: " Mumbai to Shani Shingnapur Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Shani Shingnapur cab service, providing safe, comfortable, and affordable pilgrimage travel for families, groups, and devotees. Shani Shingnapur is one of Maharashtra’s most famous spiritual destinations dedicated to Lord Shani, located in Ahmednagar district, approximately 350 km from Mumbai. Our professional drivers ensure a smooth, punctual, and stress-free journey with well-maintained vehicles suitable for long-distance temple travel. We offer flexible options including one-way drops, round trips, and customized darshan packages covering nearby religious destinations. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Shani Shingnapur cab service.",

"topPlaces": [
  {
    "title": "Shani Shingnapur Temple",
    "description": "Shani Shingnapur Temple is one of the most unique and powerful temples in India dedicated to Lord Shani Dev, the deity associated with justice and karma. The village is famous for its tradition where houses traditionally have no doors or locks, symbolizing strong faith in Lord Shani. Devotees from across Maharashtra and India visit this sacred site to seek blessings, remove Shani dosha, and experience its deeply spiritual atmosphere. It is the main attraction for pilgrims traveling from Mumbai by cab."
  },
  {
    "title": "Shani Shingnapur Village",
    "description": "The entire village surrounding the temple is known for its unique cultural belief system and spiritual environment. Visitors experience traditional Maharashtrian rural life along with strong devotional practices. The village is well-organized for pilgrims, with food stalls, dharamshalas, and facilities for large crowds visiting throughout the year."
  },
  {
    "title": "Ahmednagar City",
    "description": "Ahmednagar is the nearest major city to Shani Shingnapur and serves as an important transit hub for travelers. It is known for its historical forts, military significance, and cultural heritage. Many pilgrims traveling from Mumbai via cab stop here for food, rest, or sightseeing during their journey."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi is another major pilgrimage destination located near Shani Shingnapur, dedicated to Sai Baba. Many travelers combine both destinations in a single cab trip to experience spiritual blessings from two powerful temples in Maharashtra. The temple attracts millions of devotees every year."
  },
  {
    "title": "Ellora Caves (Optional Extension)",
    "description": "Ellora Caves, a UNESCO World Heritage Site located near Aurangabad, feature magnificent rock-cut temples and sculptures representing Hindu, Buddhist, and Jain traditions. Some travelers extend their Shani Shingnapur trip to include this historical marvel for a complete cultural and spiritual journey."
  },
  {
    "title": "Nashik Trimbakeshwar Route",
    "description": "The route connecting Shani Shingnapur to Nashik and Trimbakeshwar is part of a popular pilgrimage circuit in Maharashtra. Travelers often explore multiple Jyotirlinga temples in a single trip, making cab travel the most convenient option for a comfortable and flexible journey."
  },
  {
    "title": "Nevasa Temple Region",
    "description": "Nevasa is a nearby spiritual region associated with ancient Hindu mythology and religious history. It is considered an important stop for devotees exploring the Shani Shingnapur pilgrimage belt, offering a calm and traditional rural spiritual experience."
  },
  {
    "title": "Pathardi Area",
    "description": "Pathardi is a town near Shani Shingnapur known for its agricultural landscape and rural Maharashtra culture. It is commonly passed through during cab journeys, offering scenic countryside views and a peaceful travel experience."
  },
  {
    "title": "Devgad Ghat Region",
    "description": "The Devgad Ghat region along the route offers scenic highway driving through small hills and rural landscapes. It enhances the overall travel experience with natural beauty and smooth highway connectivity for pilgrims traveling from Mumbai."
  },
  {
    "title": "Maharashtra Temple Circuit",
    "description": "The Maharashtra temple circuit including Shani Shingnapur, Shirdi, Trimbakeshwar, and Tuljapur forms one of the most important pilgrimage routes in India. Many devotees travel this circuit by cab for a comfortable, flexible, and spiritually fulfilling journey across multiple sacred destinations."
  }
],






services: [
  {
    name: "Mumbai to Shani Shingnapur Cab",
    description: "Mumbai to Shani Shingnapur cab service offers a comfortable and spiritual journey to one of Maharashtra’s most revered temples. Ideal for devotees and family trips, this service ensures smooth highway travel with experienced drivers. Clean and well-maintained vehicles enhance comfort. It guarantees a peaceful and hassle-free yatra experience."
  },
  {
    name: "Mumbai to Shani Shingnapur Taxi",
    description: "Mumbai to Shani Shingnapur taxi provides private and convenient travel for pilgrimage journeys. This service includes door-to-door pickup and flexible travel schedules. Suitable for families and groups. It ensures a smooth and reliable journey."
  },
  {
    name: "Mumbai to Shani Shingnapur Cab Service",
    description: "Mumbai to Shani Shingnapur cab service offers professional travel solutions with multiple vehicle options. This service is ideal for religious trips and long-distance travel. Clean vehicles and trained drivers ensure comfort. It ensures a safe and pleasant journey."
  },
  {
    name: "Mumbai to Shani Shingnapur Taxi Service",
    description: "Mumbai to Shani Shingnapur taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is ideal for temple visits and family travel. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Cab from Mumbai to Shani Shingnapur",
    description: "Cab from Mumbai to Shani Shingnapur offers a convenient way to travel between cities with complete comfort. This service is ideal for devotees preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Shani Shingnapur",
    description: "Taxi from Mumbai to Shani Shingnapur provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Shani Shingnapur Cab Booking",
    description: "Mumbai to Shani Shingnapur cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Shani Shingnapur Taxi Booking Online",
    description: "Mumbai to Shani Shingnapur taxi booking online provides a quick and convenient way to plan your pilgrimage. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Shani Shingnapur Cab Price",
    description: "Mumbai to Shani Shingnapur cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Shani Shingnapur Taxi Fare",
    description: "Mumbai to Shani Shingnapur taxi fare is designed to be affordable and transparent. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Shani Shingnapur One Way Cab",
    description: "Mumbai to Shani Shingnapur one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Shani Shingnapur Round Trip Taxi",
    description: "Mumbai to Shani Shingnapur round trip taxi provides complete travel solutions including return journeys. This service is ideal for devotees planning same-day or multi-day visits. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Shani Shingnapur Innova Cab",
    description: "Mumbai to Shani Shingnapur Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Shani Shingnapur Ertiga Cab",
    description: "Mumbai to Shani Shingnapur Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Shani Shingnapur Sedan Cab",
    description: "Mumbai to Shani Shingnapur sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Shani Shingnapur SUV Taxi",
    description: "Mumbai to Shani Shingnapur SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Shani Shingnapur Cab", "Mumbai to Shani Shingnapur Taxi"],
  ["Mumbai to Shani Shingnapur Cab Service", "Mumbai to Shani Shingnapur Taxi Service"],
  ["Cab from Mumbai to Shani Shingnapur", "Taxi from Mumbai to Shani Shingnapur"],
  ["Mumbai to Shani Shingnapur Cab Booking", "Mumbai to Shani Shingnapur Taxi Booking Online"],
  ["Mumbai to Shani Shingnapur Cab Price", "Mumbai to Shani Shingnapur Taxi Fare"],
  ["Mumbai to Shani Shingnapur One Way Cab", "Mumbai to Shani Shingnapur Round Trip Taxi"],
  ["Mumbai to Shani Shingnapur Innova Cab", "Mumbai to Shani Shingnapur Ertiga Cab"],
  ["Mumbai to Shani Shingnapur Sedan Cab", "Mumbai to Shani Shingnapur SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Shani Shingnapur Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Shani Shingnapur cab service, ideal for religious trips and family travel."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in temple routes, ensuring safe driving and smooth travel to Shani Shingnapur."
  },
  {
    WhyChooseheading: "Perfect for Religious Darshan Trips",
    WhyChoosedescription: "Plan your Shani Shingnapur temple darshan conveniently with our reliable and well-organized cab services."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Shani Shingnapur trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Shani Shingnapur cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Shani Shingnapur cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Shani Shingnapur cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Shani Shingnapur for one-way and round trips." },
  { question: "What is the distance between Mumbai and Shani Shingnapur?", answer: "The distance is approximately 280 to 300 km and takes around 6 to 7 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Shani Shingnapur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for same-day return?", answer: "Yes, same-day return trips are available for Shani Shingnapur darshan." },
  { question: "Do you provide temple darshan packages?", answer: "Yes, we provide customized darshan packages for Shani Shingnapur and nearby temples." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and religious occasions." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh More",
    feedback: "The Mumbai to Shani Shingnapur cab journey with Royal Route Cabs was very smooth and well-managed. The driver was experienced and made the long spiritual trip comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shubhangi Deshmukh",
    feedback: "Good experience for our Shani Shingnapur darshan from Mumbai. The cab was clean, the ride was calm, and the overall journey felt safe and peaceful.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shani Shingnapur Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-shani-shingnapur-cab.jpg", // replace if needed
  "description": "Book Mumbai to Shani Shingnapur cab service with Royal Route Cabs for safe, reliable, and comfortable pilgrimage travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 trusted outstation taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999", // approx package price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-shani-shingnapur-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Shani Shingnapur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Shani Shingnapur cab with Royal Route Cabs. Safe and comfortable pilgrimage taxi service with affordable fares, expert drivers, and 24x7 availability."
  />

  <meta
    name="keywords"
    content="mumbai to shani shingnapur cab, mumbai to shani shingnapur taxi, mumbai to shani shingnapur cab service, mumbai to shani shingnapur taxi service, cab from mumbai to shani shingnapur, taxi from mumbai to shani shingnapur, mumbai to shani shingnapur cab booking, mumbai to shani shingnapur taxi booking online, mumbai to shani shingnapur cab price, mumbai to shani shingnapur taxi fare, mumbai to shani shingnapur one way cab, mumbai to shani shingnapur round trip taxi, mumbai to shani shingnapur innova cab, mumbai to shani shingnapur ertiga cab, mumbai to shani shingnapur sedan cab, mumbai to shani shingnapur suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshanishingnapurcab;